import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {EventResponse} from "../../../model/response/event/event-response.model";
import {EventService} from "../../../../service/api/event.service";
import {MessageToastService} from "../../../../service/message-toast.service";
import {FilePondFile} from "filepond";
import {tap} from "rxjs";
import {ApiResponse} from "../../../model/response/ApiResponse";
import {FileUploadComponent} from "../../file-upload/file-upload.component";

@Component({
    selector: 'app-edit-event-image',
    templateUrl: './edit-event-image.component.html',
    standalone: false
})
export class EditEventImageComponent implements OnInit, OnDestroy {

  @Input('event') event: EventResponse
  @Input('display') displayModal: boolean
  @Output('onEventSubmitted') eventSubmittedEmiter = new EventEmitter()
  @Output('onCancelModal') onCancelModalEmitter = new EventEmitter()

  eventImage: FilePondFile;
  redactOpen = false
  redactFile: Blob | null = null
  redactedFile: File | null = null
  redactedPreview: SafeUrl | null = null
  private originalFile: File | null = null
  private redactedPreviewUrl: string | null = null

  @ViewChild("fileUploadComponent") fileUploadComponent :  FileUploadComponent

  apiErrors: Map<string, string> = new Map<string, string>()

  constructor(
    private eventService: EventService,
    private messageService: MessageToastService,
    private sanitizer: DomSanitizer,
  ) {
  }

  ngOnInit(): void {
  }

  onFileUpdate($event: FilePondFile[]) {
    const next = $event[0]
    const changed = next?.id !== this.eventImage?.id || next?.file !== this.eventImage?.file
    this.eventImage = next
    if (!next?.file) {
      this.clearRedacted()
      this.redactOpen = false
      return
    }
    if (changed) {
      this.clearRedacted()
      this.redactFile = next.file
      this.redactOpen = true
    }
  }

  ngOnDestroy(): void {
    this.revokeRedactedPreview()
  }

  openRedact() {
    if (this.redactFile) {
      this.redactOpen = true
    }
  }

  onImageRedacted(result: {original: File, redacted: File}) {
    this.revokeRedactedPreview()
    this.originalFile = result.original
    this.redactedFile = result.redacted
    this.redactFile = result.original
    this.redactOpen = false
    this.redactedPreviewUrl = URL.createObjectURL(result.redacted)
    this.redactedPreview = this.sanitizer.bypassSecurityTrustUrl(this.redactedPreviewUrl)
  }

  private clearRedacted() {
    this.redactFile = null
    this.redactedFile = null
    this.originalFile = null
    this.revokeRedactedPreview()
  }

  private revokeRedactedPreview() {
    if (this.redactedPreviewUrl) {
      URL.revokeObjectURL(this.redactedPreviewUrl)
      this.redactedPreviewUrl = null
    }
    this.redactedPreview = null
  }

  onRedactClosed() {
    this.redactOpen = false
  }

  onApiEditImage() {
    this.eventService.editEventImage(this.event.id, this.eventImage, this.originalFile ?? undefined, this.redactedFile ?? undefined)
      .pipe(tap({
        next: value => {
          this.messageService.success(value.message)
          this.eventSubmittedEmiter.emit(value)
          this.cancelModal()
        },
        error: (error: ApiResponse<void>) => {
          this.apiErrors = error?.formErrors ?? new Map()
          this.messageService.error(error?.message)
        }
      }))
      .subscribe()
  }

  cancelModal(){
    this.displayModal = false
    this.eventImage = null;
    this.clearRedacted()
    this.redactOpen = false
    this.fileUploadComponent.myPond.removeFiles()
    this.onCancelModalEmitter.emit()
  }

}
